import React from "react";
import { ApiLinkedButtonV3 } from "../components/common/Form/ApiLinked.button.V3";
import { FormikSwitchInput } from "../components/common/input/FormikSwitch.input";
import { reloadWindowPromise } from "../components/common/reloadCallback";
import { BookingApi } from "./Booking.Api";

interface BookingUndoCancelButtonProps {
  bookingId: string;
  onSuccess?: (response: any) => Promise<void>;
  className?: string;
}

export function BookingUndoCancelButton(props: BookingUndoCancelButtonProps) {
  return (
    <span className={`BookingUndoCancelButton`}>
      <ApiLinkedButtonV3
        className={`btn-warning ${props.className}`}
        uniqueKey={`booking-${props.bookingId}-undo-cancel`}
        buttonProps={{
          content: { normal: `Undo Cancel` },
        }}
        api={BookingApi.undoCancel({
          bookingId: props.bookingId,
          notifyParticipants: false,
        })}
        successCallback={props.onSuccess || reloadWindowPromise}
        apiFormBody={
          <div>
            Are you sure that you want to undo the cancellation for this
            booking?
            <FormikSwitchInput
              name={"notifyParticipants"}
              label={`Do you want to send a notification for this action?`}
              required={false}
            />
          </div>
        }
        formModalSize={"md"}
      />
    </span>
  );
}
